import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-gift',
	templateUrl: './icon-gift.component.svg',
})
export class IconGiftComponent {}
